import { createFileRoute } from '@tanstack/react-router'
import { ReferralIntakeSettings } from '@/features/organizations/settings/referral-intake'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/referral-intake',
)({
  component: ReferralIntakeSettings,
})
